var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.059,
    height: 46.334,
    viewBox: "0 0 55.059 46.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -6.348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.225,14.3a10,10,0,0,1,4.656,7.433A8.072,8.072,0,1,0,33.225,14.3Zm-5.29,16.533a8.075,8.075,0,1,0-8.076-8.074A8.075,8.075,0,0,0,27.935,30.834Zm3.425.55H24.509A10.351,10.351,0,0,0,14.17,41.724V50.1l.021.131.577.181a47.062,47.062,0,0,0,14.058,2.267c7.6,0,12-2.166,12.275-2.3l.539-.273H41.7V41.724A10.348,10.348,0,0,0,31.361,31.384Zm13.36-8.336h-6.8A9.952,9.952,0,0,1,34.85,29.98a12.285,12.285,0,0,1,8.775,11.757v2.582a27.823,27.823,0,0,0,10.836-2.276L55,41.769h.058V33.387A10.35,10.35,0,0,0,44.72,23.048ZM13.766,22.5a8.021,8.021,0,0,0,4.294-1.246,9.993,9.993,0,0,1,3.756-6.374c.008-.151.023-.3.023-.453A8.074,8.074,0,1,0,13.766,22.5Zm7.252,7.481a9.957,9.957,0,0,1-3.069-6.893c-.252-.019-.5-.038-.759-.038H10.339A10.351,10.351,0,0,0,0,33.387v8.381l.021.129.577.182a48.476,48.476,0,0,0,11.643,2.188V41.736A12.288,12.288,0,0,1,21.018,29.98Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStudents);
export default __webpack_public_path__ + "static/media/TotalStudents.66df8bf8.svg";
export { ForwardRef as ReactComponent };